export default {
  ZH_HK: {
    startTime: "開始時間",
    endTime: "結束時間",
    name: "名稱",
    participant: "參與者",
    time: "時間",
    minute: "分鐘",
    dialogueRecord: "記錄",
    discussionTopic: "討論主題",
    discussionTopicNum: "討論主題數",
    maxNumDialogue: "最高对话數",
    minNumDialogue: "最低對話數",
    dialogueTotalNum: "對話總數",
    operate: "操作",
    viewDetails: "查看詳細",
    answered: "已回答",
    fraction: "分數",
    AIDiscussion: "AI 討論內容",
    Vote: "投票",
    AISummary: "AI 總結",
    WordCloud: "詞雲",
    Rating: "評分",
    VoteDebate: "投票辯論",
    Reading: "閱讀理解",
    StudentDebate: "學生辯論",
    module: "模塊",
    numOfPeople: "人數",
    participation: "參與度",
    Votingcontent: "投票內容",
    Wordcloudcontent: "詞雲內容",
    Scoringcontent: "評分內容",
    Readingaccuracyrate: "閱讀理解正確度",
    Debatecontent: "辯論內容",
    total: "總人數",
    participants: "參與人數",
    people: "人",
    inputActivityName: "請輸入活動名稱",
    chartData: "圖表數據",
    articleContent: "文章內容",
    questionAnswer: "問題回答",
    proSide: "正方",
    conSide: "反方",
    Scoringrationale: "評分理由",
    ParticipationRound: "參與環節",
    DiscussionCount: "討論次數",
    points: "分",
    word: "詞語",
    VoteChoice: "投票選擇",
    VoteContent: "投票內容",
    SelectAnswer: "選擇答案",
    NoLastData: "沒有上一條數據",
    NoNextData: "沒有下一條數據",
    CompletionTime: "完成時間"
  },
  zh_cn: {
    startTime: "开始时间",
    endTime: "结束时间",
    name: "名称",
    participant: "参与者",
    time: "时间",
    minute: "分钟",
    dialogueRecord: "记录",
    discussionTopic: "讨论主题",
    discussionTopicNum: "讨论主题数",
    maxNumDialogue: "最高对话数",
    minNumDialogue: "最低对话数",
    dialogueTotalNum: "对话总数",
    operate: "操作",
    viewDetails: "查看详细",
    answered: "已回答",
    fraction: "分数",
    AIDiscussion: "AI 讨论内容",
    Vote: "投票",
    AISummary: "AI 总结",
    WordCloud: "词云",
    Rating: "评分",
    VoteDebate: "投票辩论",
    Reading: "阅读理解",
    StudentDebate: "学生辩论",
    module: "模块",
    numOfPeople: "人数",
    participation: "参与度",
    Votingcontent: "投票内容",
    Wordcloudcontent: "词云内容",
    Scoringcontent: "评分内容",
    Readingaccuracyrate: "阅读理解正确度",
    Debatecontent: "辩论内容",
    total: "总人数",
    participants: "参与人数",
    people: "人",
    inputActivityName: "请输入活动名称",
    chartData: "图表数据",
    articleContent: "文章内容",
    questionAnswer: "问题回答",
    proSide: "正方",
    conSide: "反方",
    Scoringrationale: "评分理由",
    ParticipationRound: "参与环节",
    DiscussionCount: "讨论次数",
    points: "分",
    word: "词语",
    VoteChoice: "投票选择",
    VoteContent: "投票内容",
    SelectAnswer: "选择答案",
    NoLastData: "没有上一条数据",
    NoNextData: "没有下一条数据",
    CompletionTime: "完成时间"
  },
  EN: {
    startTime: "Start Time",
    endTime: "End Time",
    name: "Name",
    participant: "Participant",
    time: "Time",
    minute: "min",
    dialogueRecord: "Record",
    discussionTopic: "Discussion Topic",
    discussionTopicNum: "Topics",
    maxNumDialogue: "Max Dialogues",
    minNumDialogue: "Min Dialogues",
    dialogueTotalNum: "Total Dialogues",
    operate: "Action",
    viewDetails: "View Details",
    answered: "Answered",
    fraction: "Score",
    AIDiscussion: "AI Discussion",
    Vote: "Vote",
    AISummary: "AI Summary",
    WordCloud: "Word Cloud",
    Rating: "Rating",
    VoteDebate: "Vote Debate",
    Reading: "Reading",
    StudentDebate: "Student Debate",
    module: "Module",
    numOfPeople: "Number of People",
    participation: "Participation",
    Votingcontent: "Voting Content",
    Wordcloudcontent: "Word Cloud Content",
    Scoringcontent: "Scoring Content",
    Readingaccuracyrate: "Reading Accuracy Rate",
    Debatecontent: "Debate Content",
    total: "Total",
    participants: "Participants",
    people: "People",
    inputActivityName: "Please enter the activity name",
    chartData: "Chart Data",
    articleContent: "Article Content",
    questionAnswer: "Question Answer",
    proSide: "Pro side",
    conSide: "Con side",
    Scoringrationale: "Scoring Rational",
    ParticipationRound: "Participation Round",
    DiscussionCount: "Discussion Count",
    points: "Points",
    word: "Word",
    VoteChoice: "Vote Choice",
    VoteContent: "Vote Content",
    SelectAnswer: "Select Answer",
    NoLastData: "No previous entry",
    NoNextData: " No next entry",
    CompletionTime: "Completion Time"
  },
  es: {
    startTime: "Hora de inicio",
    endTime: "Hora de fin",
    name: "Nombre",
    participant: "Participante",
    time: "Tiempo",
    minute: "min",
    dialogueRecord: "Registro",
    discussionTopic: "Tema de discusión",
    discussionTopicNum: "Temas",
    maxNumDialogue: "Diálogos máx",
    minNumDialogue: "Diálogos mín",
    dialogueTotalNum: "Total diálogos",
    operate: "Acción",
    viewDetails: "Ver detalles",
    answered: "Respondido",
    fraction: "Puntuación",
    AIDiscussion: "Discusión IA",
    Vote: "Votación",
    AISummary: "Resumen IA",
    WordCloud: "Nube palabras",
    Rating: "Puntuación",
    VoteDebate: "Debate votación",
    Reading: "Lectura",
    StudentDebate: "Debato Estudiantil",
    module: "Módulo",
    numOfPeople: "Número de Personas",
    participation: "Participación",
    Votingcontent: "Contenido de votación",
    Wordcloudcontent: "Contenido de nube de palabras",
    Scoringcontent: "Contenido de puntuación",
    Readingaccuracyrate: "Precisión de lectura",
    Debatecontent: "Contenido de debate",
    total: "Total",
    participants: "Participantes",
    people: " personas",
    inputActivityName: "Por favor ingrese el nombre del evento",
    chartData: "Datos del gráfico",
    articleContent: "Contenido del artículo",
    questionAnswer: "Respuesta de la pregunta",
    proSide: "Lado afirmativo",
    conSide: "Lado negativo",
    Scoringrationale: "Racional de puntuación",
    ParticipationRound: "Ronda de participación",
    DiscussionCount: "número de intervenciones",
    points: "Puntos",
    word: "Palabra",
    VoteChoice: "Elección de voto",
    VoteContent: "Contenido de voto",
    SelectAnswer: "Respuesta seleccionada",
    NoLastData: "No hay entrada anterior ",
    NoNextData: "No hay entrada siguiente",
    CompletionTime: "Tiempo de finalización"
  }
};
